export const version = "networks/5.5.0";
//# sourceMappingURL=_version.js.map